module.exports = __webpack_public_path__ + "img/off_despaletizadora.49aeeba8.png";